import React from "react";
import ShakingTextChar from "./ShakingTextChar";
interface ShakingTextProps{
    text:string;
}

const ShakingText:React.FC<ShakingTextProps> = (props) => {
    return(
        <div style={{display:"Flex"}}>
            <div style={{flexGrow:1}}/>
            {props.text.split("").map((c,i)=><ShakingTextChar offset={i * 0.1}>{c}</ShakingTextChar>)}
            <div style={{flexGrow:1}}/>
        </div>
    )
}

export default ShakingText;